var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AbstractContractorInput',_vm._g(_vm._b({attrs:{"items":_vm.contractors,"loading":_vm.loggedCompanyLoading},on:{"input":_vm.emitContractor}},'AbstractContractorInput',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }